import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

import UtilSequence from "@/utils/UtilSequence.mjs";

export default {

    async criaDespesa(despesaValores = {}){

        let ordemDePagamentoDespesa;

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            despesaValores = {
                despesa: despesaValores?.despesa || "",
                dataCriacao: despesaValores?.dataCriacao || "",
                dataDaDespesa: despesaValores?.dataDaDespesa || "",
                valor: despesaValores?.valor || 0,
                veicular: despesaValores?.veicular || false,
                veiculoTipo: despesaValores?.veiculoTipo || "Nenhum",
                veiculoPlaca: despesaValores?.veiculoPlaca || "",
                veiculoKMInicial: despesaValores?.veiculoKMInicial || 0,
                veiculoKMFinal: despesaValores?.veiculoKMFinal || 0,
                observacao: despesaValores?.observacao ?? "",
                anexos: despesaValores?.anexos ?? [],
            };

            //==================================================================//
            //================= CRIA DESPESA ORDEM DE PAGAMENTO ================//
            //==================================================================//

            ordemDePagamentoDespesa = await ERP.postOneOld(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
            if(ordemDePagamentoDespesa.status != 200){
                throw ordemDePagamentoDespesa;
            }

            console.log(ordemDePagamentoDespesa);

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesa;

        }

        return ordemDePagamentoDespesa;

    },

    async criaDespesas(despesasValores = []){

        let ordemDePagamentoDespesas = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            despesasValores = despesasValores.map((despesa = {}) => ({
                despesa: despesa?.despesa || "",
                dataCriacao: despesa?.dataCriacao || "",
                dataDaDespesa: despesa?.dataDaDespesa || "",
                valor: despesa?.valor || 0,
                veicular: despesa?.veicular || false,
                veiculoTipo: despesa?.veiculoTipo || "Nenhum",
                veiculoPlaca: despesa?.veiculoPlaca || "",
                veiculoKMInicial: despesa?.veiculoKMInicial || 0,
                veiculoKMFinal: despesa?.veiculoKMFinal || 0,
                observacao: despesa?.observacao ?? "",
                anexos: despesa?.anexos ?? [],
            }));

            //==================================================================//
            //================ CRIA DESPESAS ORDEM DE PAGAMENTO ================//
            //==================================================================//

             ordemDePagamentoDespesas.data = await UtilSequence.each({
                list: despesasValores,
                callback: async (despesaValores)=>{

                    let ordemDePagamentoDespesa = await ERP.postOneOld(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
                    if(ordemDePagamentoDespesa.status != 200){
                        throw ordemDePagamentoDespesa;
                    }

                    console.log(ordemDePagamentoDespesa);

                    return ordemDePagamentoDespesa.data;

                }
            });

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesas;

        }

        return ordemDePagamentoDespesas;

    },

    async alteraDespesa(despesaValores = {}){

        let ordemDePagamentoDespesa;

        try{

            //==================================================================//
            //================ ALTERA DESPESA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            ordemDePagamentoDespesa = await ERP.patchOneOld(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
            if(ordemDePagamentoDespesa.status != 200){
                throw ordemDePagamentoDespesa;
            }

            console.log(ordemDePagamentoDespesa);

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesa;

        }

        return ordemDePagamentoDespesa;

    },

    async alteraDespesas(despesasValores = []){

        let ordemDePagamentoDespesas = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //================ CRIA DESPESAS ORDEM DE PAGAMENTO ================//
            //==================================================================//

             ordemDePagamentoDespesas.data = await UtilSequence.each({
                list: despesasValores,
                callback: async (despesaValores)=>{

                    let ordemDePagamentoDespesa = await ERP.patchOneOld(Schema.ORDEM_DE_PAGAMENTO_DESPESAS, despesaValores);
                    if(ordemDePagamentoDespesa.status != 200){
                        throw ordemDePagamentoDespesa;
                    }

                    console.log(ordemDePagamentoDespesa);

                    return ordemDePagamentoDespesa.data;

                }
            });

        }catch(e){

            console.log(e);
            return ordemDePagamentoDespesas;

        }

        return ordemDePagamentoDespesas;

    },

}